/**
 * Import the React library and the Loader image from the specified path.
 * @module
 * @requires React
 * @requires ../../assets/images/giphy.gif
 */
import React from "react";
/**
 * A custom button component that renders a button element with customizable properties.
 * @param {Object} props - The properties for the button component.
 * @param {string} props.title - The title of the button.
 * @param {ReactNode} props.children - The child elements of the button.
 * @param {boolean} props.disabled - Whether the button is disabled or not.
 * @param {string} props.type - The type of the button.
 * @param {boolean} props.loading - Whether the button is in a loading state or not.
 * @param {string} props.className - The CSS class name for the button.
 * @param {ReactNode} props.icon - The icon element to display within the button.
 */
const CustomButton = ({ title, children, disabled, type, loading = false, className = "", icon, id, onKeyDown, onClick }) => {
  return (
    <button
      id={id}
      className={
        disabled
          ? "Button-disable"
          : className + loading
          ? "custombtn btn-loading " + className
          : "custombtn " + className
      }
      type={type}
      onKeyDown={onKeyDown}
      disabled={disabled || loading}
      onClick={onClick}
    >
      {loading && (
        <>
          <div className="btn-loader">
            <div className="spinner-border text-light" role="status" />
          </div>
        </>
      )}
      <>
        {icon}
        {title}
      </>
      {children}
    </button>
  );
};

export default CustomButton;
